/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormItemProps } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { ReactElement, useState } from 'react'
import { CustomFormInstance } from '../types'
import {
    getMachineElements,
    getCompositionElements,
    getManufactureElements,
    getMethodElements,
} from '../utils'
import {
    CompositionForm,
    FormValues,
    MachineForm,
    MachineNames,
    ManufactureForm,
    MethodsForm,
    SharedNames,
} from '../utils/forms/methods/types'
import { statusType } from '../pages/Projects/Projects.types'

type Question<T = any> = {
    name: keyof T
    formInputProps?: FormItemProps
    component: ReactElement
    onNext?: () => void
    onPrev?: (fieldValue: string | undefined | any) => void
    isLastQuestion?: boolean
}
export type getQuestions = {
    method: Questions
    manufacture: Questions
    machine: Questions
    composition: Questions
}

// export type Questions<T = any> = Record<keyof T, Question<T>>
export type Questions<T = any> = {
    [key in keyof T]: Question<T>
}

export type ValidQuestionKeys =
    | keyof MethodsForm
    | keyof MachineForm
    | keyof CompositionForm
    | keyof ManufactureForm

const useGerateQuestions = (
    category: keyof typeof getQuestions,
    functions?: any
) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
    const [currentProject, setCurrentProject] = useState({})
    const [form] = useForm()
    const [activeQuestions, setActiveQuestions] = useState<ValidQuestionKeys[]>(
        ['titleComponent']
    )

    const options = {
        form,
        setActiveQuestions,
        activeQuestions,
        currentQuestionIndex,
        setCurrentQuestionIndex,
        functions,
    }
    const getQuestions: getQuestions = {
        method: getMethodElements(options as any),
        manufacture: getManufactureElements(options as any),
        machine: getMachineElements(options as any),
        composition: getCompositionElements(options as any),
    }
    const questionsList = getQuestions[category]

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onFormChange = (newValue: Record<string, string | undefined>) => {
        // const [fieldKey, fieldValue] = Object.entries(newValue)[0]
        // questionsList[fieldKey].onChange(fieldValue)
    }
    const setInitialQuestions = (questions: (keyof FormValues)[]) => {
        setActiveQuestions(questions)
    }
    const selectedQuestions = [...activeQuestions].map((fieldName) => {
        return questionsList[fieldName as string]
    })

    const STATUS_VALUES = Object.values(statusType).filter(
        (v) => typeof v === 'number'
    ) as number[]

    const getTotalSteps = () => {
        switch (category) {
            case 'machine':
                return new Set([
                    ...Object.keys(MachineNames),
                    ...Object.keys(SharedNames),
                ]).size
            default:
                return activeQuestions.length || 1
        }
    }

    const totalSteps = getTotalSteps()

    const getProgressStatus = (
        currentIndex: number,
        steps: number
    ): statusType => {
        const isLast = selectedQuestions[currentIndex]?.isLastQuestion
        if (isLast) {
            return statusType.e
        }
        if (steps <= 1) return statusType.a

        const ratio = currentIndex / (steps - 1)
        const statusIndex = Math.round(ratio * (STATUS_VALUES.length - 1))

        return STATUS_VALUES[statusIndex] as statusType
    }

    // percentage based on current index vs total Enum length
    const progress: statusType = getProgressStatus(
        currentQuestionIndex,
        totalSteps
    )

    return {
        activeQuestions,
        onFormChange,
        setInitialQuestions,
        selectedQuestions,
        formRef: form as CustomFormInstance<FormValues>,
        currentQuestionIndex,
        setCurrentQuestionIndex,
        currentProject,
        setCurrentProject,
        progress,
    }
}

export default useGerateQuestions
